import MDModal from 'components/MDModal';
import React, { useState, useEffect } from 'react';
import "../style.css";
import { useAgencyInfo } from 'context/agency';
import CreatePromptCategory from '../PromptCategory/Create';
import CreatePromptSubCategory from '../PromptSubCategory/Create';
import ReactSelect, { components } from 'react-select';
import AnimatedText from 'layouts/super-admin/components/Animation/AnimatedText';
import LoadingDots from 'layouts/super-admin/components/Animation/LoadingDots';
import Icon from 'layouts/super-admin/components/Icon';
import { useUserInfo } from 'context/user';
import {
  useCustomTaskAssistant,
  useGeneratePartnerTaskPrompt,
  useAvailableBranding,
  useCreatePartnerTask,
} from 'queries/prompts';
import { useQueryClient } from '@tanstack/react-query';

function Create({ openModel, onclosemodel, data, modelfunctionality, RefreshTabs }) {
  const [agency] = useAgencyInfo();
  const [promptSetAs, setPromptSetAs] = useState("personal");

  const [formData, setFormData] = useState({
    promptName: '',
    category: null,
    subCategory: '',
    description: '',
    setas: "personal",
    jobRoles: [],
    sectors: [],
    integrations: []
  });
  const [jobRolesList, setJobRolesList] = useState([]);
  const [sectorsList, setSectorsList] = useState([]);
  const [categoriesList, setCategoriesList] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [isCategoryModel, setIsCategoryModel] = useState(false);
  const [isSubCategoryModel, setIsSubCategoryModel] = useState(false);
  const user = useUserInfo()[0]

  const [promptQuery, setPromptQuery] = useState("");
  const [promptstep, setpromptstep] = useState(0);
  const [promptQueryError, setPromptQueryError] = useState('');
  const [promptNameError, setPromptNameError] = useState(null);
  const [promptContentError, setPromptContentError] = useState(null);
  const [promptName, setPromptName] = useState();
  const [promptContent, setPromptContent] = useState();
  const [processing, setProcessing] = useState(false);
  const [showAddNewPrompt, setShowAddNewPrompt] = useState(false);
  const [showAddCategoryModal, setShowAddCategoryModal] = useState(false);
  const [promptCategory, setPromptCategory] = useState('');
  const [promptCategoryError, setPromptCategoryError] = useState(null);
  const [showAddSubCategoryModal, setShowAddSubCategoryModal] = useState(false);
  const [promptSubCategory, setPromptSubCategory] = useState('');
  const [promptSubCategoryError, setPromptSubCategoryError] = useState(null);
  const queryClient = useQueryClient();

  const { mutateAsync: getCustomTaskAssistant } = useCustomTaskAssistant();
  const { mutateAsync: generatePartnerTaskPrompt } = useGeneratePartnerTaskPrompt();

  const GeneratePrompt = async () => {
    setpromptstep(1);
    const { response: customTaskAssistant } = await getCustomTaskAssistant(agency._id);
    try {
      const payload = {
        agency_id: agency._id,
        username: "Agency Prompt Generator",
        promptQuery: promptQuery,
        user_id: user?.user_id,
        ...(customTaskAssistant ? { assistant_id: customTaskAssistant?.data?.assistant_id } : {})
      }

      const response = await generatePartnerTaskPrompt(payload)

      if (response) {
        setpromptstep(2);
        setFormData((prevData) => ({
          ...prevData,
          promptName: response?.response?.data?.title || '',
          description: response?.response?.data?.content || ''
        }));
      }

    } catch (error) {
      return error;
    }
  };

  const handlestep1 = () => {
    if (promptQuery === "") {
      setPromptQueryError(true);
      return false;
    }
    setPromptQueryError(false);
    GeneratePrompt();
  }

  const handleAddCategory = () => {
    setShowAddCategoryModal(true);
  };

  const handleAddSubCategory = () => {
    setShowAddSubCategoryModal(true);
  };

  // Dead code: `SSO` and `selectedOption` are not defined anywhere in this
  // file (would throw ReferenceError if ever invoked) and nothing in the
  // component calls handlePromptSubmit - the form below submits via
  // handleSubmit/createPartnerTask instead. Left exactly as-is (just the
  // transport swapped) per instructions not to fix unrelated bugs.
  const handlePromptSubmit = async () => {
    setProcessing(true);

    setPromptNameError(null);
    setPromptCategoryError(null);
    setPromptSubCategoryError(null);
    setPromptContentError(null);
    setShowAddNewPrompt(false)
    let hasError = false;

    if (!promptName) {
      setPromptNameError("Prompt Name is required");
      hasError = true;
    }


    if (!promptContent) {
      setPromptContentError("Prompt Content is required");
      hasError = true;
    }

    if (hasError) {
      setProcessing(false);
      return;
    }

    const payload = {
      title: promptName,
      category: promptCategory,
      sub_category: promptSubCategory,
      prompt_value: promptContent,
      agency_id: SSO?.agency_id,
      type: "agency",
      userId: { id: SSO?.userUUID, type: "author", username: SSO?.chat_username },
      locationId: SSO?.id,
      set_as: promptSetAs,
      assistant_name: selectedOption,
      active: true,
    };

    const { response } = await createPartnerTask(payload);


    setProcessing(false);

  };

  useEffect(() => {
    if (data) {
      setFormData((prevData) => ({
        ...prevData,
        promptName: data.title || '',
        category: categoriesList.find(c => c.value === data.category) || null,
        subCategory: data.subCategory || '',
        description: data.description || ''
      }));
    }
  }, [data, categoriesList]);



  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  useEffect(() => {
    if (agency) {
      if (agency.job_roles) {
        setJobRolesList(agency.job_roles.map(role => ({ value: role._id || role.id, label: role.name })));
      }
      if (agency.sectors) {
        setSectorsList(agency.sectors.map(sector => ({ value: sector._id || sector.id, label: sector.name })));
      }
      if (agency.Categories) {
        setCategoriesList(agency.Categories.map(category => ({
          value: category.id || category._id || category.name,
          label: category.name
        })));
      }
    }
  }, [agency]);

  const { data: integrationsList = [] } = useAvailableBranding({
    enabled: !!(agency?._id && user?.user_id),
  });

  const handleMultiChange = (name) => (selectedOptions) => {
    setFormData({
      ...formData,
      [name]: selectedOptions || []
    });
  };

  const handleSingleChange = (name) => (selectedOption) => {
    setFormData({
      ...formData,
      [name]: selectedOption || null
    });
  };

  const CustomOption = (props) => {
    return (
      <components.Option {...props}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
            style={{ marginRight: '10px', height: '16px', width: '16px' }}
          />
          <label style={{ fontSize: '14px', fontWeight: '500', color: '#344767', marginBottom: 0 }}>{props.label}</label>
        </div>
      </components.Option>
    );
  };

  const selectStyles = {
    control: (base) => ({
      ...base,
      padding: '5px',
      borderRadius: '8px',
      borderColor: '#d2d6da',
      '&:hover': {
        borderColor: '#000'
      },
      boxShadow: 'none'
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: '14px',
      color: '#92A5AF'
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? '#f8f9fa' : 'white',
      color: '#344767',
      '&:active': {
        backgroundColor: '#e9ecef'
      }
    }),

    menuPortal: (base) => ({ ...base, zIndex: 9999 })
  };

  const menuPortalProps = {
    menuPortalTarget: document.body,
    menuPosition: 'fixed',
    maxMenuHeight: 250
  };

  const { mutateAsync: createPartnerTask } = useCreatePartnerTask();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setProcessing(true);
    const payload = {
      title: formData.promptName,
      prompt_value: formData.description,
      category: formData.category?.value || '',
      job_roles: formData.jobRoles.map(r => r.value),
      sectors: formData.sectors.map(s => s.value),
      integrations: formData.integrations.map(i => i.value),
      agency_id: agency._id,
      type: "agency",
      active: true,
    };

    try {
      const { response } = await createPartnerTask(payload);
      if (response) {
        onclosemodel();
        queryClient.invalidateQueries({ queryKey: ["partner-tasks"] })
        if (RefreshTabs) RefreshTabs();
      }
    } catch (error) {
      console.error(error);
    } finally {
      setProcessing(false);
    }
  };


  const handleCategoryModel = () => {
    setIsCategoryModel(true);
  }

  const closeCategoryModel = () => {
    setIsCategoryModel(false);
  }

  const handleSubCategoryModel = () => {
    setIsSubCategoryModel(true);
  }

  const closeSubCateggoryModel = () => {
    setIsSubCategoryModel(false);
  }
  const detectEnterPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      handlestep1();
    };
  }


  return (
    <div className=''>
      {openModel &&
        <div className="modal-zz-confirm text-left "  >

          <div className="scrollable-modal-content bg-white  rounded custom_task_modal" style={{ position: "relative" }} >
            {promptstep !== 1 ?
              <>
                <span className='crossison' onClick={onclosemodel}>X</span>
              </> : ''
            }
            {promptstep === 0 && (
              <>
                <p className="modalText">Add a task</p>
                <p className="roundofaddprompt z-w-60" style={{ display: 'flex', alignItems: 'center' }}>
                  <Icon id={'magicstar'} />
                  <AnimatedText text="What do you want to do?" style={{ marginLeft: '20px' }} speed={50} />
                </p>
                <div className="input-container">
                  <textarea
                    value={promptQuery}
                    required
                    placeholder="Start Typing ..."
                    name="promptQuery"
                    onChange={(e) => setPromptQuery(e.target.value)}
                    onKeyDown={(e) => detectEnterPress(e)}
                    className="input_od_addPrompt"
                    style={{
                      width: '100%',
                      padding: '20px',
                      borderRadius: '8px',
                      maxHeight: "200px",
                      resize: 'none',
                    }}
                    rows={1}
                    onInput={(e) => {
                      e.target.style.height = 'auto';
                      e.target.style.height = `${e.target.scrollHeight}px`;
                    }}
                  />

                  <button
                    onClick={handlestep1}
                    className="send-button"
                  >
                    <Icon id="sendChat" className="chat__input-icon" />
                  </button>
                </div>
                {promptQueryError && (
                  <small style={{ color: "red" }}>Should not be empty</small>
                )}
              </>
            )}
            {promptstep === 1 && <>
              <p className="roundofaddprompt z-w-100 text-center"
                style={{ marginBottom: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Icon id={'magicstar'} />
                <span style={{ display: 'inline-block', marginLeft: '10px' }}>Creating task</span>
                <LoadingDots speed={100} />
              </p>
            </>
            }

            {promptstep === 2 && <>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <p className="modalText" style={{ margin: 0 }}>Add a task</p>
              </div>

              <div className="roundofaddprompt" style={{ width: '100%', display: 'flex', alignItems: 'flex-start', background: '#F8F9FA', borderRadius: '12px', padding: '15px' }}>
                <div style={{ marginRight: '12px', marginTop: '4px' }}>
                  <Icon id={'magicstar'} />
                </div>
                <p style={{ margin: 0, fontSize: '14px', color: '#1A1A1A', fontWeight: '500' }}>
                  Here’s your prompt, feel free to edit it using the the pencilblack tool...
                </p>
              </div>

              <div style={{ marginTop: '20px' }}>
                <h2 className='text-black text-left' style={{ fontSize: '16px', fontWeight: '800', marginBottom: '15px' }}>Create Task</h2>

                <form onSubmit={handleSubmit}>
                  <div className='w-100 margin_fix'>
                    <label className='new_dezin_label text-black'>Task Title</label>
                    <input
                      type="text"
                      name='promptName'
                      className='w-100 form-control-agust input_od_addPrompt'
                      style={{
                        padding: '12px',
                        borderRadius: '8px',
                        border: '1px solid #d2d6da',
                        marginTop: '5px'
                      }}
                      value={formData.promptName}
                      onChange={handleChange}
                      placeholder="Enter task title..."
                    />
                  </div>

                  <div className='w-100 margin_fix' style={{ marginTop: '15px' }}>
                    <label className='new_dezin_label text-black'>Task</label>
                    <textarea
                      rows={6}
                      name='description'
                      className='w-100 form-control-agust input_od_addPrompt'
                      style={{
                        padding: '12px',
                        borderRadius: '8px',
                        border: '1px solid #1A1A1A',
                        marginTop: '5px',
                        resize: 'none'
                      }}
                      value={formData.description}
                      onChange={handleChange}
                    />
                  </div>

                  <div className='w-100 margin_fix' style={{ marginTop: '15px' }}>
                    <label className='new_dezin_label text-black'>Category</label>
                    <ReactSelect
                      options={categoriesList}
                      styles={selectStyles}
                      placeholder="Select category..."
                      isClearable
                      value={formData.category}
                      onChange={handleSingleChange('category')}
                      {...menuPortalProps}
                    />
                  </div>

                  <div className='w-100 margin_fix' style={{ marginTop: '15px' }}>
                    <label className='new_dezin_label text-black'>Job Role</label>
                    <ReactSelect
                      isMulti
                      options={jobRolesList}
                      components={{ Option: CustomOption }}
                      styles={selectStyles}
                      placeholder="Select job roles..."
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      value={formData.jobRoles}
                      onChange={handleMultiChange('jobRoles')}
                      {...menuPortalProps}
                    />
                  </div>

                  <div className='w-100 margin_fix' style={{ marginTop: '15px' }}>
                    <label className='new_dezin_label text-black'>Sector</label>
                    <ReactSelect
                      isMulti
                      options={sectorsList}
                      components={{ Option: CustomOption }}
                      styles={selectStyles}
                      placeholder="Select sector..."
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      value={formData.sectors}
                      onChange={handleMultiChange('sectors')}
                      {...menuPortalProps}
                    />
                  </div>

                  <div className='w-100 margin_fix' style={{ marginTop: '15px' }}>
                    <label className='new_dezin_label text-black'>Integrations</label>
                    <ReactSelect
                      isMulti
                      options={integrationsList}
                      components={{ Option: CustomOption }}
                      styles={selectStyles}
                      placeholder="Select integrations..."
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      value={formData.integrations}
                      onChange={handleMultiChange('integrations')}
                      {...menuPortalProps}
                    />
                  </div>

                  <div className='w-100' style={{ marginTop: '30px' }}>
                    <button type='submit' className='btn-newdezine' style={{ padding: '15px', fontSize: '16px', fontWeight: '600' }}>Save</button>
                  </div>
                </form>
              </div>
            </>}


          </div>
        </div>}

    </div>
  );
}

export default Create;
